import { useState } from "react";
import RigthButton from "assets/svg/rightButton.svg";
import LeftButton from "assets/svg/leftButton.svg";
import Image from "next/image";
import RigthButtonNot from "assets/svg/rigthButtonNot.svg";
import LeftButtonNot from "assets/svg/leftButtonNot.svg";
import { useTranslation } from "react-i18next";

type ProtoType = {
  goToPage: (currentpage: number) => void;
  pageSize?: number;
  t: any;
  totalPages?: number;
  crntpage?: number;
  fillPage?: boolean;
};
const ManualTablePagination: React.FC<ProtoType> = ({
  goToPage,
  pageSize = 50,
  t,
  totalPages,
  crntpage,
  fillPage,
}) => {
  const [currentPage, setCurrentpage] = useState<number>(1);
  const { i18n } = useTranslation();
  const canNextPage = (): boolean => {
    if (currentPage < totalPages) {
      return true;
    } else {
      return false;
    }
  };
  const canGoPrev = (): boolean => {
    if (currentPage - 1 > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      className={`w-full    flex flex-col justify-center sm:flex-row sm:justify-between items-center pt-3 pb-4 px-4 text-[#969696]  flex-wrap `}
    >
      <div className="flex items-center gap-2">
        <span className="flex gap-1 capitalize">
          <span>{t("page")}</span>
          <span>{currentPage}</span>
          <span>{t("of")}</span>
          <span> {totalPages}</span>
        </span>
      </div>

      <div className="flex gap-10">
        <div className="flex items-center gap-2">
          <span className="capitalize ">{t("perPage")}</span>

          {[10, 25, 50].map((value, i) => (
            <div
              key={i + Math.random()}
              className="border w-[27px] h-[27px] cursor-pointer flex items-center justify-center"
            >
              {value}
            </div>
          ))}
        </div>
        <div className="flex gap-2 leading-8 select-none bottom-10 align-center">
          <button
            onClick={() =>
              canGoPrev()
                ? (goToPage(currentPage - 1), setCurrentpage(currentPage - 1))
                : null
            }
            disabled={!canGoPrev()}
            className={`font-semibold border p-2 flex items-center justify-center ${
              canGoPrev() ? `text-dark-gray` : `text-gray-300`
            } text-lg outline-none focus:outline-none disabled:cursor-not-allowed`}
          >
            <Image
              src={
                i18n.language === "en"
                  ? canGoPrev()
                    ? LeftButton
                    : LeftButtonNot
                  : canGoPrev()
                  ? RigthButton
                  : RigthButtonNot
              }
              alt="img"
            />
          </button>

          <button
            onClick={() =>
              canNextPage()
                ? (setCurrentpage(currentPage + 1), goToPage(currentPage + 1))
                : null
            }
            disabled={!canNextPage()}
            className={`font-semibold border p-2 flex items-center justify-center${
              canNextPage() ? `text-dark-gray` : `text-gray-300`
            } text-lg outline-none focus:outline-none disabled:cursor-not-allowed`}
          >
            <Image
              src={
                i18n.language === "en"
                  ? canNextPage()
                    ? RigthButton
                    : RigthButtonNot
                  : canNextPage()
                  ? LeftButton
                  : LeftButtonNot
              }
              alt="img"
            />
          </button>
        </div>
      </div>
    </div>
  );
};
export default ManualTablePagination;
